import {
  callApiDangNhap,
  callApiSyncData,
  callApiLayTinhThanh,
  callApiLayDanhSachLevel,
  callApiGetPermission,
  callApiChangeGenerateSetupCode,
  callApiConfirmUsing,
  callApiValidateLogin,
} from "@/api/common";
import {
  LOCAL_STORAGE_KEY,
  setValueToStorageByKey,
} from "@/utils/localStorage";

const setIsLogin = (context, isLogin) => {
  setValueToStorageByKey(LOCAL_STORAGE_KEY.IS_LOGIN, isLogin);
  context.commit("SET_IS_LOGIN", isLogin);
};
const login = (context, payload) => {
  return callApiDangNhap(payload);
};

const setPermission = (context) => {
  let payload = {
    appCode: "COMMON",
  };
  return callApiGetPermission(payload).then((res) => {
    let listPermission = res.data.data;
    context.commit("SET_LIST_PERMISSION", listPermission);
    setValueToStorageByKey(LOCAL_STORAGE_KEY.PERMISSIONS, listPermission);
  });
};

const setBreadcrumb = (context, breadcrumb) => {
  context.commit("SET_BREADCRUMB", breadcrumb);
};

const setAppId = (context, appId) => {
  setValueToStorageByKey(LOCAL_STORAGE_KEY.APP_ID, appId);
  context.commit("SET_APP_ID", appId);
};

const setIsIframe = (context, payload) => {
  setValueToStorageByKey("isIframe", payload);
  context.commit("SET_IS_IFRAME", payload);
};

const setUserInfo = (context, userInfo) => {
  context.commit("SET_USER_INFO", userInfo);
};

const syncData = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSyncData()
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layTinhThanh = async (context, payload) => {
  const response = await callApiLayTinhThanh(payload.data);
  if (response && response.data.succeeded) {
    payload.onSuccess && payload.onSuccess(response.data.data);
  }
};

const layDanhSachLevel = async (context) => {
  const response = await callApiLayDanhSachLevel();
  if (response && response.data.succeeded) {
    context.commit("SET_LIST_LEVEL", response.data.data);
  }
};

const changeGenerateSetupCode = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiChangeGenerateSetupCode()
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response)
        });
  });
};

const validateLogin = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiValidateLogin(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response)
        });
  });
};

const confirmUsing = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiConfirmUsing(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response)
        });
  });
};

export default {
  setIsLogin,
  login,
  setBreadcrumb,
  setAppId,
  setUserInfo,
  syncData,
  layTinhThanh,
  layDanhSachLevel,
  setPermission,
  setIsIframe,
  changeGenerateSetupCode,
  validateLogin,
  confirmUsing,
};
